<template>
  <img :src="src" :alt="alt" class="harit-logo" :class="{ 'is-white': white }"
    :style="{ height: typeof height === 'number' ? height + 'px' : height }" />
</template>

<script>
/**
 * Harit brand lockup — the official artwork supplied by HCL Foundation.
 *
 * The source file is a 2750x1250 canvas with the logo sitting in the middle
 * surrounded by whitespace, and carries no viewBox. Both files here have been
 * given a viewBox cropped to the measured artwork bounds so they scale to the
 * requested height instead of rendering tiny inside a mostly empty box:
 *
 *   harit-logo.svg  viewBox="773 317 1203 615"  full lockup
 *   harit-mark.svg  viewBox="775 319 451 447"   ring + sapling only
 *
 * The white variant is derived from the colour artwork with a CSS filter
 * rather than loading the separate white file. That keeps one source of truth,
 * and the supplied white PNG has the same whitespace padding, which cannot be
 * cropped from a bitmap the way a viewBox crops the vector.
 */
import fullSrc from '@/assets/brand/harit-logo.svg'
import markSrc from '@/assets/brand/harit-mark.svg'

export default {
  name: 'HaritLogo',
  props: {
    // 'full' = mark + wordmark, 'mark' = the ring/sapling on its own.
    variant: { type: String, default: 'full' },
    // 'white' is the knockout version for the green masthead.
    theme: { type: String, default: 'color' },
    height: { type: [Number, String], default: 46 },
  },
  computed: {
    white() {
      return this.theme === 'white'
    },
    src() {
      return this.variant === 'mark' ? markSrc : fullSrc
    },
    alt() {
      return this.variant === 'mark' ? 'Harit' : 'Harit by HCL Foundation'
    },
  },
}
</script>

<style scoped>
.harit-logo {
  display: block;
  width: auto;
  max-width: 100%;
}

/* brightness(0) flattens the artwork to black, invert(1) lifts it to pure
   white — an exact knockout regardless of the source colours. */
.harit-logo.is-white {
  filter: brightness(0) invert(1);
}
</style>
